import React, {PureComponent} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupText, InputGroupAddon, Input } from 'reactstrap'
import PropTypes from 'prop-types';

import IconClose from '../../images/tutup-button.png';

class AWB extends PureComponent {
  _textInput = (e) => {
    this.numberAWB = e.target.value
  }

  _submit = () => {
    this.props.onToggle(true, this.numberAWB)
  }

  render(){
    return(
      <Modal isOpen={this.props.isOpen} toggle={this.props.onToggle} contentClassName={this.props.classContent} className={this.props.className}>
        <ModalHeader>
          {this.props.textTittle}
          <KickImage onClick={()=>this.props.onToggle(false)} className="btn-close-modal close-modal_filter" src={IconClose} alt="close"/>
        </ModalHeader>
        <ModalBody>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                {this.props.infoInput}
              </InputGroupText>
            </InputGroupAddon>
            <Input onChange={this._textInput}/>
          </InputGroup>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-white" color="success" onClick={this._submit}>Submit</Button>{' '}
          <Button color="danger" className={"btn-awb-cancel"} onClick={this.props.onToggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

AWB.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  classContent: PropTypes.string,
  textTittle: PropTypes.string.isRequired,
  infoInput: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  onClickAcc: PropTypes.func,
  onClickDec: PropTypes.func,
}

AWB.defaultProps = {
  isOpen: false,
  className: 'AWB',
  classContent: 'AWB',
  textTittle: 'Modal Tittle',
  infoInput: 'To the Left!',
  onClickAcc: () => {},
  onClickDec: () => {},
  onToggle: () => {},
}

export default AWB